import React from "react";

interface IProps {
  fill?: string;
}

const InfoIconRed:React.FC<IProps> = ({fill="#E03923"}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 1.375C3.44568 1.375 1.375 3.44568 1.375 6C1.375 8.55432 3.44568 10.625 6 10.625C8.55432 10.625 10.625 8.55432 10.625 6C10.625 3.44568 8.55432 1.375 6 1.375ZM0.625 6C0.625 3.03147 3.03147 0.625 6 0.625C8.96853 0.625 11.375 3.03147 11.375 6C11.375 8.96853 8.96853 11.375 6 11.375C3.03147 11.375 0.625 8.96853 0.625 6ZM5.625 4C5.625 3.79289 5.79289 3.625 6 3.625H6.005C6.21211 3.625 6.38 3.79289 6.38 4C6.38 4.20711 6.21211 4.375 6.005 4.375H6C5.79289 4.375 5.625 4.20711 5.625 4ZM6 5.25006C6.20711 5.25006 6.375 5.41795 6.375 5.62506V8.62506C6.375 8.83217 6.20711 9.00006 6 9.00006C5.79289 9.00006 5.625 8.83217 5.625 8.62506V5.62506C5.625 5.41795 5.79289 5.25006 6 5.25006Z"
        fill={fill || "#E03923"}
      />
    </svg>
  );
};

export default InfoIconRed;
